import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import ChartWidget from '../ChartWidget';
import DataTable from '../DataTable';
import { lookupColumnTemporal, tooltipDetailChartProps } from '../../utils/tooltipDetail';
import TooltipDetailStyleButton from './TooltipDetailStyleButton';

/** Subgráfico del tooltip del heatmap, con los mismos componentes que el dashboard. */
export default function TooltipDetailChart({
  detail,
  rows,
  columnDurationFormats,
  columnDateFormats,
  columnDateBuckets,
  onStyleChange,
  minHeight = 260,
}) {
  const [columnFilters, setColumnFilters] = useState({});
  const temporal = { columnDateFormats, columnDateBuckets };
  const chartProps = tooltipDetailChartProps(detail, temporal);
  const xTemporal = lookupColumnTemporal(temporal, detail?.chart?.xColumn);

  const chartBody = !rows?.length ? (
    <Box sx={{ minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Typography variant="body2" color="text.secondary">
        Sin datos para este filtro.
      </Typography>
    </Box>
  ) : chartProps.type === 'table' ? (
    <Box sx={{ minHeight, display: 'flex', flexDirection: 'column' }}>
      <DataTable
        data={rows}
        visibleColumns={chartProps.columns?.length ? chartProps.columns : null}
        columnDurationFormats={columnDurationFormats || {}}
        columnDateFormats={chartProps.columnDateFormats}
        columnDateBuckets={chartProps.columnDateBuckets}
        columnFilters={columnFilters}
        onColumnFilterChange={(col, values) => setColumnFilters((prev) => ({ ...prev, [col]: values }))}
        onClearAllFilters={() => setColumnFilters({})}
      />
    </Box>
  ) : (
    <Box
      sx={{
        ...(chartProps.type === 'intervals' ? { minHeight } : { height: minHeight, minHeight }),
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ChartWidget
        {...chartProps}
        data={rows}
        columnDurationFormats={columnDurationFormats}
      />
    </Box>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <TooltipDetailStyleButton
        chart={detail?.chart}
        xIsTemporal={Boolean(xTemporal.dateDisplayFormat || xTemporal.dateBucket)}
        onChange={
          onStyleChange
            ? (style) => onStyleChange(style)
            : undefined
        }
      />
      {chartBody}
    </Box>
  );
}
